export const PAUSED_PAYMENTS_REPORT_UPDATED = "PAUSED_PAYMENTS_REPORT_UPDATED";
export const PAUSED_PAYMENTS_REPORT_COMPLETED = "PAUSED_PAYMENTS_REPORT_COMPLETED";
